import { render, staticRenderFns } from "./templateAnalysisList.vue?vue&type=template&id=3c0658c7&scoped=true"
import script from "./templateAnalysisList.vue?vue&type=script&lang=js"
export * from "./templateAnalysisList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0658c7",
  null
  
)

export default component.exports